import { render, staticRenderFns } from "./AttendInventory.vue?vue&type=template&id=d56e6b32&lang=pug&"
import script from "./AttendInventory.vue?vue&type=script&lang=js&"
export * from "./AttendInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports